// Mirrors the backend App\Enum\PlanningBoardEntryType. Used as the `entryTypes[]`
// filter values on the PSP planning-board list endpoint. Keep in sync with the
// generated `FilterListsResponse2.entryTypes` union.
export enum PlanningBoardEntryType {
  FixedShift = 'fixed_shift',
  FlexibleShift = 'flexible_shift',
  Absence = 'absence',
  FreeShift = 'free_shift',
}
